import { Cell } from "../Cell";
import { ReportStatusBadge } from "../ReportStatusBadge";
import { EvictionReportContent } from "./EvictionReportContent";
import { ApplicantOrInvitee, Verification } from "../../types";
import { useAuthContext } from "providers/Auth";
import { Applicant } from "types/application";

interface EvictionReportCellProps {
  verification: Verification;
  applicant: ApplicantOrInvitee;
  hasAuditFlagEnabled: boolean;
}

export const EvictionReportCell = ({
  verification,
  applicant,
  hasAuditFlagEnabled
}: EvictionReportCellProps) => {
  const { permissions } = useAuthContext();
  return (
    <Cell
      isDataCell
      className="relative"
      isPermitted={permissions.canAccessReports.housingCourtReport}
      showRestrictedFlag={!permissions.canAccessReports.housingCourtReport}
    >
      <EvictionReportContent
        verification={verification}
        applicant={applicant}
        hasAuditFlagEnabled={hasAuditFlagEnabled}
      />
      <ReportStatusBadge
        verification={verification}
        applicant={applicant as Applicant}
      />
    </Cell>
  );
};
